<template>
  <div class="change-password-dialog">
    <el-dialog append-to-body :title="addEditType == 1 ? '新增菜单' : '修改菜单'" :visible="isShow" :close-on-click-modal="false" @close="closeDialog" width="600px">
      <el-form class="form" :model="vForm" :rules="rules" ref="vForm" label-width="80px" auto-complete="off" size="medium">
        <el-form-item label="排序" class="form-group" prop="sort">
          <el-input type="text" class="form-control" v-model="vForm.sort" placeholder="数字越小排序越靠前"></el-input>
        </el-form-item>
        <!--        <el-form-item label="菜单归属" class="form-group">-->
        <!--          <el-radio v-model="vForm.origin_type" :label="2" :disabled="!(addEditType == 1 && !row)">SaaS</el-radio>-->
        <!--          <el-radio v-model="vForm.origin_type" :label="1" :disabled="!(addEditType == 1 && !row)">平台</el-radio>-->
        <!--        </el-form-item>-->
        <el-form-item label="菜单名称" class="form-group" prop="title">
          <el-input type="text" class="form-control" v-model="vForm.title" placeholder="如：首页"></el-input>
        </el-form-item>
        <el-form-item label="页面路径" class="form-group" prop="path">
          <el-input type="text" class="form-control" v-model="vForm.path" placeholder="如：/index"></el-input>
        </el-form-item>
        <el-form-item v-if="vForm.pid === 0" label="菜单图标" class="form-group" prop="icon">
          <el-input type="text" class="form-control" v-model="vForm.icon" placeholder="如：home"></el-input>
        </el-form-item>
        <!--        <el-form-item label="是否缓存" class="form-group" prop="is_cache">-->
        <!--          <el-radio v-model="vForm.is_cache" :label="1">缓存</el-radio>-->
        <!--          <el-radio v-model="vForm.is_cache" :label="2">不缓存</el-radio>-->
        <!--        </el-form-item>-->
        <el-form-item label="是否启用" class="form-group" prop="is_show">
          <el-radio v-model="vForm.is_show" :label="1">启用</el-radio>
          <el-radio v-model="vForm.is_show" :label="2">禁用</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['isShow', 'addEditType', 'row'],
  data() {
    return {
      doSubmitLoading: false,
      vForm: {
        id: '',
        sort: 10000,
        path: '',
        type: 1,
        is_show: 1, // 是否隐藏 1是 2否
        icon: '',
        pid: this.addEditType == 1 && !!this.row ? this.row.id : 0,
        title: '',
        is_cache: 1, // 是否缓存 1是 2否
        origin_type: 2, //1平台 2SaaS
      },
      rules: {
        title: { required: true, message: '菜单名称必填', trigger: 'blur' },
        path: { required: true, message: '页面路径必填', trigger: 'blur' },
      },
    };
  },
  created() {
    if (this.addEditType == 2) {
      for (let key in this.row) {
        this.vForm[key] = this.row[key];
      }
    }
  },

  methods: {
    closeDialog() {
      this.$emit('update:isShow', false);
    },
    doSubmit() {
      this.$refs.vForm.validate(async (valid) => {
        if (valid) {
          this.doSubmitLoading = true;
          try {
            let res = await this.api.userAdmin[this.addEditType == 1 ? 'addPermission' : 'editPermission'](this.vForm);
            this.$message.success(res.message);
            this.doSubmitLoading = false;
            this.closeDialog();
            this.$emit('getlist');
          } catch (ex) {
            this.doSubmitLoading = false;
          }
        }
      });
    },
  },
};
</script>
